function hide() {
  $('#flash .flash-message').fadeOut("slow", function() {
    $(this).remove();
  })
};

$(document).ready(function(){
  setTimeout(hide, 5000); // Increased timeout to 5 seconds for better UX
});
